import { makeStyles } from "@material-ui/core/index.js";

export default makeStyles((theme) => ({
    mainDiv: {
        marginTop: '63px',
        height: 'fit-content',
        minHeight: 'calc(100vh - 63px)',
        boxSizing: 'borderbox',
        color: '#282828',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('xs')]: {
            marginTop: '55px',
        },
    },
    container: {
        padding: '0px 3vw',
        paddingTop: '20px',
        boxSizing: 'border-box',
        backgroundColor: '#e2e2e2',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        margin: '0px auto',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'space-around',
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    formAdWrap: {
        height: 'fit-content',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    heading: {
        padding: '8px',
        fontSize: '26px',
        fontWeight: '500',
        color: '#282828',
        //textAlign: 'center',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '22px',
        },
    },
    content: {
        fontWeight: '500',
        margin: '6px',
        border: '1px solid #aaaaaa',
        borderRadius: '6px',
        padding: '24px',
        fontSize: '16px',
        flexGrow: 1,
        letterSpacing: '0.8px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#e8e8e8',
    },
    createRoomBox: {
        maxWidth: '650px',
        borderRadius: '4px',
        width: '40%',
        marginLeft: '4px',
        marginRight: '4px',
        backgroundColor: '#e2e2e2',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            width: '46%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    joinRoomBox: {
        maxWidth: '650px',
        marginLeft: '4px',
        marginRight: '4px',
        width: '40%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('md')]: {
            width: '46%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    middleSpace: {
        display: 'block',
        height: '100%',
        [theme.breakpoints.down('lg')]: {
            width: '4vw',
        },
        [theme.breakpoints.up('lg')]: {
            width: '8vw',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '20px',
        },
    },
    publicRooms: {
        padding: '0px 3vw',
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: '#e2e2e2',
        display: 'flex',
        flexDirectiom: 'row',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    publicAdWrap: {
        width: '100%',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
            width: '90%',
            margin: '0px auto',
        },
    },
    publicRoomsContent: {
        width: '100%',
        backgroundColor: '#e2e2e2',
    },
    cardGroup: {
        width: '100%',
        flexWrap: 'wrap',
        display: 'flex',
        justifyContent: 'space-around',
    },
    roomCard: {
        height: '30vw',
        marginTop: '20px',
        marginBottom: '20px',
        width: '30vw',
        borderRadius: '6px',
        display: 'flex',
        border: '1px solid #aaaaaa',
        flexDirection: 'column',
        backgroundColor: '#e8e8e8',
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            width: '45vw',
            height: '45vw',
        },
        [theme.breakpoints.down('xs')]: {
            width: '90vw',
            height: '90vw',
        },
    },
    textCenter: {
        textAlign: 'center',
    },
    separator: {
        margin: '40px auto',
        width: '90%',
        height: '2px',
        borderRadius: '2px',
        backgroundColor: '#cccccc',
    },
    listContent: {
        padding: '4px',
        color: '#484848',
        lineHeight: '1.6',
        letterSpacing: '0.6px',
        fontWeight: '400',
        [theme.breakpoints.up('lg')]: {
            fontSize: '16px',
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '-10px',
            fontSize: '13px',
            letterSpacing: '0.5px',
        },
    },
    buttonRoom: {
        position: 'relative',
        letterSpacing: '0.5px',
        marginTop: '16px',
        '&:hover': {
            backgroundColor: '#282828',
            color: '#e2e2e2',
        },
    },
    formRoom: {
        position: 'relative',
        paddingTop: '26px',
        paddingLeft: '30px',
        paddingBottom: '20px',
        boxSizing: 'border-box',
    },
    checkbox: {
        margin: '2px 8px 0px 8px',
        [theme.breakpoints.down('xs')]: {
            margin: '2px 0px 0px -10px',
        },
    },
    publicImageDiv: {
        width: '100%',
        flexGrow: 1,
        overflow: 'hidden',
        marginTop: '-30px',
        backgroundColor: '#e2e2e2',
        boxSizing: 'border-box',
        borderBottom: '1px solid #aaaaaa',
    },
    publicImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    publicBottomDiv: {
        position: 'relative',
        height: '60px',
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    publicDescDiv: {
        display: 'flex',
        paddingLeft: '12px',
        letterSpacing: '0.4px',
        boxSizing: 'border-box',
    },
    publicBtnDiv: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '12px',
        boxSizing: 'border-box',
    },
    publicBtn: {
        letterSpacing: '0.5px',
        width: '80px',
        '&:hover': {
            backgroundColor: '#282828',
            color: '#e2e2e2',
        },
    },
    publicOnline: {
        position: 'relative',
        left: '-8px',
        height: '30px',
        width: '70px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#282828',
        zIndex: 10,
        transform: 'skew(-30deg)',
        backgroundColor: '#e2e2e2',
        borderBottom: '1px solid #aaaaaa',
        borderRight: '1px solid #aaaaaa',
    },
    publicOnlineDiv: {
        transform: 'skew(30deg)',
        paddingLeft: '30px',
        display: 'flex',
        alignItems: 'center',
    },
    userIcon: {
        position: 'absolute',
        fontSize: '14px',
        left: '10px',
    },
    publicErrorDiv: {
        width: '70%',
        borderRadius: '6px',
        border: '1px solid #aaaaaa',
        margin: '25px auto',
        padding: '30px',
        boxSizing: 'border-box',
        fontSize: '18px',
        backgroundColor: '#e8e8e8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#585858',
        letterSpacing: '0.4px',
        fontWeight: '500',
        [theme.breakpoints.down('sm')]: {
            padding: '20px',
            width: '80%',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '16px',
            padding: '25px',
            width: '90%',
        },
    },
    errorIcon: {
        fontSize: '24px',
        color: '#888888',
        margin: '0px 15px 0px -10px',
    },
    adBlock: {
        margin: '20px auto',
        boxSizing: 'border-box',
        width: '84%',
        display: 'none',
        height: '300px',
        backgroundColor: '#e8e8e8',
        borderRadius: '4px',
        border: '1px solid #aaaaaa',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    createErrorDiv: {
        position: 'fixed',
        top: '200px',
        zIndex: 100,
        maxWidth: '100%',
        width: 'fit-content',
        marginTop: '4px',
        padding: '8px',
        border: '1px solid #d0b8b8',
        backgroundColor: '#f0d8d8',
        color: '#484848',
        letterSpacing: '0.4px',
        borderRadius: '2px',
        fontSize: '14px',
        fontWeight: 400,
        display: 'none',
    },
    joinErrorDiv: {
        position: 'fixed',
        top: '200px',
        zIndex: 100,
        maxWidth: '100%',
        width: 'fit-content',
        marginTop: '4px',
        padding: '8px',
        border: '1px solid #d0b8b8',
        backgroundColor: '#f0d8d8',
        color: '#484848',
        letterSpacing: '0.4px',
        borderRadius: '2px',
        fontSize: '14px',
        fontWeight: 400,
        display: 'none',
    }
}))

